import { render, staticRenderFns } from "./ItemizeScenic.vue?vue&type=template&id=3f566420"
import script from "./ItemizeScenic.vue?vue&type=script&lang=js"
export * from "./ItemizeScenic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports